import { useCallback, useEffect, useState } from "react";
import { fetchSrmUsers } from "../../models/shared/agentsUsersModel";

export function useAgentsUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async ({ force = false } = {}) => {
    setLoading(true);
    setUsers(await fetchSrmUsers({ force }));
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const refresh = useCallback(() => load({ force: true }), [load]);

  return { users, loading, refresh };
}
